import BaseSettingHandler from './BaseSettingHandler';
import type { Atom } from '@/app/editor/iframe/atom/Atom';
import type { AtomModel } from '@/app/editor/iframe/atom/Atom.model';
import { DataManager } from '@/app/editor/iframe/atom/service/DataManager';

/**
 * Setting Extra Class
 */
export class ShExtraClass extends BaseSettingHandler {
  public atom?: Atom;
  public targetSelector: string;
  /**
   * constructor
   * @param inputName inputName
   * @param targetSelector string
   * @param atom atom
   */
  constructor(inputName?: string, targetSelector?: string, atom?: Atom) {
    super();
    this.inputName = inputName || '';
    this.atom = atom;
  }

  /**
   * read setting
   * @param options options
   * @param options.$activePanel $activePanel
   */
  read(options: { $activePanel: JQuery; atomModel?: AtomModel }) {
    const id: any = options.atomModel ? options.atomModel.id : this.atom?.data.atom.id;
    const $atom = DataManager.getAtomDomById(id);
    if ($atom) {
      const $target = $atom.find(this.setting.targetSelector as string);
      const value = $target.attr('data-exc') as string;
      if (!$target.hasClass(value)) {
        $target.addClass(value);
      }
      options.$activePanel
        .find(`[name="${this.setting.name}"]`)
        .attr('value', value)
        .val(value)
        .trigger('value-change');
      return { value: value };
    }
  }

  /**
   * write setting
   * @param value value
   * @returns refreshType
   */
  write(
    value: string,
    options: {
      atomModel?: AtomModel;
    },
  ) {
    const id: any = options.atomModel ? options.atomModel.id : this.atom?.data.atom.id;
    const $atom = DataManager.getAtomDomById(id);
    const targetSelector = this.setting.targetSelector as string;
    const $target = $atom.hasClass(targetSelector) ? $atom : $atom.find(targetSelector);
    let oldExtraClass = $target.attr('data-exc');
    if (!oldExtraClass) {
      oldExtraClass = '';
    }
    if (value) {
      const newExtraClass = value.replace(/[^a-z0-9_\-\\ ]/gi, '');
      if (oldExtraClass != newExtraClass) {
        $target.removeClass(oldExtraClass).addClass(newExtraClass).attr('data-exc', newExtraClass);
      }
    }
    return {
      refreshType: 'css',
    };
  }
}
